module.exports = __webpack_public_path__ + "static/media/casual_badge.851fd934.svg";